import { z } from 'zod'
import React from 'react'
import ReactDOM from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { BrowserRouter } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'
import App from './App'
import { DirectionProvider } from './components/DirectionProvider'
import { registerApiGatewayQueryClient } from './services/apiGateway'
import { registerAuthStoreQueryClient } from './stores/auth.store'
import './i18n'
import './index.css'
import './styles/rtl.css'

// FIX-424 Cure B — disable Zod v4 JIT `new Function()` probe to satisfy
// CSP `script-src 'self'` without `'unsafe-eval'`. Lazy at parse-time so
// placement here (before first form submit) is sufficient. Production
// posture per ADR-024 / FIX-429.
z.config({ jitless: true })

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 1,
    },
  },
})

// Lets the apiGateway request interceptor await `ensureQueryData` for the
// workspace-scoped JWT without importing the React tree (ADR-024 β-prime).
registerApiGatewayQueryClient(queryClient)
registerAuthStoreQueryClient(queryClient)

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <DirectionProvider>
          <App />
          <Toaster position="top-right" />
        </DirectionProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
)
